import { Text, type TextOptions } from "pixi.js";
import { fitTextToBox, type TextFitBox } from "./fitTextToBox";

/**
 * A `Text` with an optional `overflow: SHRINK` box: every text write re-fits the scale so
 * the string never grows past the authored `contentSize`. Anchor defaults to the centre.
 */
export class FittedText extends Text {
  private fitBox: TextFitBox | null;

  public constructor(options: TextOptions & { fitBox?: TextFitBox | null }) {
    const { fitBox, ...textOptions } = options;
    super(textOptions);
    this.fitBox = fitBox ?? null;
    if (options.anchor === undefined) this.anchor.set(0.5);
    this.refit();
  }

  public override get text(): string {
    return super.text;
  }

  public override set text(value: string) {
    super.text = value;
    this.refit();
  }

  public setFitBox(box: TextFitBox | null): void {
    this.fitBox = box;
    this.refit();
  }

  private refit(): void {
    if (!this.fitBox) return;
    fitTextToBox(this, this.fitBox);
  }
}
